module.exports = __webpack_public_path__ + "img/64800.cab53e9f.jpg";